import React from "react";
import getConfig from "next/config";
import { Form } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import { config } from "_config";

const { publicRuntimeConfig } = getConfig();

export default function RushProcessing({ onChange, trademarkRushProcessing, state, label }) {
  return (
    <div className="rush-processing">
      {config.skin === 'v2-basic' && (
        <h2>
          You’re nearly finished!
          <br />
          <br />
          Do you need your order processed faster?
        </h2>
      )}
      <img src={`${publicRuntimeConfig.basePath}/clock-icon.png`} alt="" layout="fill" />
      <div className="copy">
        <div className="optional"></div>
        <h2>
          RUSH PROCESSING.<br/> COMPLETED NEXT DAY WHEN TIME IS OF THE ESSENCE.
        </h2>
        <Typography className="regular">
          {label ? label : "We know time is critical. With Rush Processing, we will complete your search results by the next business day, and file the application immediately after you have approved it."}
        </Typography>
        <Form.Group controlId="rushProcessing">
          <Form.Check
            type="checkbox"
            className="text-left"
            checked={state.rushProcessing === true}
            name="rushProcessing"
            onChange={onChange}
            label={
              <>
                <span className="required">*</span>
                <span className="hour-24">24-hour Expedited Processing (Next Business Day):</span>&nbsp;
                <span className="price">{"$" + trademarkRushProcessing?.price?.toFixed(2) + " USD"}</span>
              </>
            }
          />
        </Form.Group>
      </div>
    </div>
  );
}
